import { Component, OnInit } from '@angular/core';
import { Organization } from '../../../model/organization';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationsService } from '../../../services/organizations.service';
import { MenuItem } from 'primeng/api';
import { translate, TranslocoService } from '@ngneat/transloco';
import { AuthGuard } from '../../../common/auth-guard.service';

@Component({
  selector: 'app-organizations-details',
  templateUrl: './organizations-details.component.html',
  styleUrls: ['./organizations-details.component.scss']
})
export class OrganizationsDetailsComponent implements OnInit {

  public navState: any;

  public organization: Organization;

  public items: MenuItem[];
  public activeItem: MenuItem;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private translocoService: TranslocoService,
              private authGuard: AuthGuard,
              private organizationsService: OrganizationsService) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => this.loadOrganization(params.uuid));

    this.translocoService.selectTranslate('common.new').subscribe(() => {
      this.items = [
        {id: 'overview', label: translate('common.overview'), icon: 'pi pi-home'},
        {id: 'devices', label: translate('model.devices'), icon: 'pi pi-mobile'},
        {id: 'assets', label: translate('model.assets'), icon: 'pi pi-map-marker'}
      ];
      if (!this.activeItem) {
        this.activeItem = this.items[0];
      }
      if (this.authGuard.adminRequired()) {
        this.items.splice(1, 0, {id: 'api', label: translate('common.api'), icon: 'pi pi-cloud'});
      }
    });
  }

  loadOrganization(organizationUuid: string): void {
    this.organizationsService.getOrganization(organizationUuid).subscribe(response => {
      this.organization = response.organization;
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
  }

}
